import { Box, Container, Divider, Grid, IconButton, Tooltip, Typography } from '@material-ui/core'
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles'
import {
    Add as AddIcon, BackspaceOutlined as BackspaceOutlinedIcon, Print as PrintIcon, Search as SearchIcon
} from '@material-ui/icons'
import Autorenew from '@material-ui/icons/Autorenew'
import ErrorIcon from '@material-ui/icons/Error'
import VisibilityIcon from '@material-ui/icons/Visibility'
import MUIDataTable from "mui-datatables"
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Date from "../../components/Form/Date"
import ComboBox from '../../components/Form/Select'
import SelectSupplier from '../../components/Form/SelectSupplier'
import TextField from '../../components/Form/TextField'
import ButtonUI from '../../components/ui/ButtonUI'
import LoadingUI from '../../components/ui/LoadingUI'
import PageTitle from '../../components/ui/PageTitleUI'
import { useAuth } from '../../hooks/auth'
import { MDFeSearch } from '../../interfaces/MDFe'
import MvmStatus from '../../interfaces/MvmStatus'
import MvmApi from '../../services/MvmApi'
import ReportApi from '../../services/ReportApi'
import utilsDate from '../../utils/Date'
import permissions from '../../utils/Permissions'
import getDefaultGridOptions, { defaultGridTheme, defaultHeaderOptions } from '../../utils/componentUtils'
import { useStyles } from './Style'

interface IFormInput {
    mvmNumber: string;
    suppliers: any;
    invoiceKey: string;
    invoiceNumber: string;
    submitDateStart: Date | null;
    submitDateEnd: Date | null;
    entranceDate: Date | null;
    exitDate: Date | null;
    status: number;
    vehiclePlateNumber: string;
    cartPlateNumber: string;
    mvmType: string;
}

const MvmAutomatico: React.FC = () => {
    const classes = useStyles()
    const [mvms, setMvms] = useState<any>()
    const [loading, setLoading] = useState(true)
    const { user, hasPermission } = useAuth()
    const { t } = useTranslation("Mvm")
    const { t: _t } = useTranslation("General")
    const history = useHistory()
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const { enqueueSnackbar } = useSnackbar();
    
    const { handleSubmit, reset, control, getValues } = useForm<IFormInput>(
        {
            defaultValues: {
                mvmNumber: '',
                suppliers: [],
                invoiceKey: '',
                invoiceNumber: '',
                submitDateStart: null,
                submitDateEnd: null,
                entranceDate: null,
                exitDate: null,
                vehiclePlateNumber: '',
                cartPlateNumber: '',
                mvmType: '',
            }
    })

    useEffect(() => {
        if (!hasPermission(permissions.MVM.Add) && 
            !hasPermission(permissions.MVM.Edit) && 
            !hasPermission(permissions.MVM.SuperUser) &&
            !hasPermission(permissions.MVM.Search) && 
            !hasPermission(permissions.MVM.Print))
            history.replace('NoPermission');
    }, [history, user]);

    const columns = [

        {
            name: 'id',
            options: {
                display: false,
            }
        },
        {
            name: 'mdFeKey',
            options: {
                display: false,
            }
        },
        {
            name: 'mvm',
            label: String(t('mvmNumber')),   
            options: {
                sort: false,
                ...defaultHeaderOptions,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return value?.mvmNumber;
                }
            }
        },
        {
            name: 'mvm',
            label: String(t('mvmSubmitDate')),
            
            options: {
                ...defaultHeaderOptions,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTimeShort(value?.submitDate);
                }
            }
        },
        {
            name: 'cnpjIssuer',
            label: String(t('shippingCompanySupplier')),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'validationDescription',
            options: {
                display: false,
            }
        },
        {
            name: 'statusDescription',
            label: String(t('status')),
            options: {
                ...defaultHeaderOptions,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return <div style={{display: 'flex', justifyContent: 'center'}}>
                        <div >{value}</div> 
                        {tableMeta.rowData[11] == 'ERRO_VALID' && (
                            <div>
                                <Tooltip title={String(tableMeta.rowData[5])} style={{marginLeft: 4}}>
                                    <ErrorIcon color='error' fontSize='medium'/>
                                </Tooltip>
                            </div>
                        )}
                        
                        </div>;
                }
            }
        },
        {
            name: 'vehiclePlateNumber',
            label: String(t('vehiclePlateNumber')),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'cTes',
            label: String(t('FinalDestination')),
            options: {
                ...defaultHeaderOptions,
                sort: false,
                customBodyRender: (value: any) => {
                    return value[0]?.cTe?.finalDestination;
                }
            }
        },
        {
            name: 'cTes',
            label: String(t('UnitCargo')),
            options: {
                ...defaultHeaderOptions,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    var lista = value.filter((x: any) => x?.cTe).map((x: any) => x?.cTe?.unitCargo);
                    var newList = lista.filter((este: any, i: any) => lista.indexOf(este) === i);

                    return newList.join(', ')
                }
            }
        },
        // {
        //     name: 'mvm',
        //     label: String(t('updatedAt')),
        //     options: {
        //         ...defaultHeaderOptions,
        //         sort: false,
        //         customBodyRender: (value: any) => {
        //             return utilsDate.DateTimeShort(value?.updatedAt);
        //         }
        //     }
        // },
        {
            name: 'status',
            label: ' ',
            options: {
                ...defaultHeaderOptions,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    const mvmEmitido = value == 'MVM_EMI';
                    return (
                        <>
                            <Box display="flex">
                                    <Tooltip title={String(_t('reprocess'))}>
                                        <IconButton onClick={() => createMvmFromMDFe(tableMeta.rowData[1])} disabled={mvmEmitido} aria-label="Reprocessar" color="primary">
                                            <Autorenew fontSize='small'/>
                                        </IconButton>
                                    </Tooltip>
                            </Box>
                        </>
                    );
                }
            }
        },
        {
            name: '',
            label: '',
            options: {
                ...defaultHeaderOptions,
                sort: false,
                display: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {

                    let canView: boolean = (hasPermission(permissions.MVM.Search) || hasPermission(permissions.MVM.SuperUser));
                    
                    return (
                        <>
                            <Box display="flex">
                                <Tooltip title={String(_t('view'))}>
                                    <a href={canView ? "/SubmitMvm/" + tableMeta.rowData[0] + "/View" : "#"}>
                                        <IconButton disabled={!canView} aria-label="View" color="primary" >
                                            <VisibilityIcon fontSize='small'/>                              
                                        </IconButton>
                                    </a>
                                </Tooltip>
                            </Box>
                            
                        </>
                    );
                }
            }
        },
        {
            name: '',
            label: '',
            options: {
                ...defaultHeaderOptions,
                sort: false,
                display: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <>
                            <Box display="flex">
                                <Tooltip title={String(_t('print'))}>
                                    <IconButton 
                                        disabled={(!hasPermission(permissions.MVM.SuperUser) && !hasPermission(permissions.MVM.Print)) || tableMeta.rowData[1] === MvmStatus.FLAG_STATUS_DRAFT}
                                    	aria-label={_t('print')} 
                                    	color="primary" 
                                    	onClick={() => print(tableMeta.rowData[0])}
                                    >
                                        <PrintIcon fontSize='small'/>
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </>
                    );
                }
            }
        }
    ]

    const createMvmFromMDFe = async (mdFeKey: any) => {
        setLoading(true);
        try{
            console.log('mdFeKey', mdFeKey);
            const result = await MvmApi.createMvmFromMDFe(mdFeKey);
            enqueueSnackbar(t("MvmIssusedSuccessfully"), { variant: 'success' });
            console.log('result', result);

        }catch(error){
            console.log('error', error);
        }

        var data = getValues()
        onSubmit(data)
        
    }

    function print(id:string)
    {
        ReportApi.printMvm(id);
    }

    const options = {
        textLabels: {
            body: {
                noMatch: _t('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: _t("next"),
                previous: _t("previous"),
                rowsPerPage: _t("rowsPerPage") + ":",
                displayRows: _t("of"),
            }
        }
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })

    useEffect(() => {
        var data = getValues()
        onSubmit(data)
    }, [history, user, page, rowsPerPage]);

    const onSubmit = (data: any) => {
        
        setLoading(true)

        //Buscar por fornecedores do usuario Fornecedor
        if (user.isSupplier && data.suppliers?.length === 0)
            data.suppliers = user.suppliers;

        let search: MDFeSearch = {
            mvmId: data.mvmNumber,
            submitDateStart: data.submitDateStart,
            submitDateEnd: data.submitDateEnd,
            vehiclePlateNumber: data.vehiclePlateNumber,
            cartPlateNumber: data.cartPlateNumber,
            mdfeKey: data.MDFeKey,
            cteKey: data.CTeKey,
            pageSize: rowsPerPage,
            pageIndex: page,
        }

        MvmApi.searchMDFe(search)
            .then(result => {
                if (result && result.items) {
                    setMvms(result)
                    setCount(result.totalCount)
                    setPage(result.pageIndex)
                }
                else {
                    setMvms([])
                    setCount(0)
                    setPage(0)
                }
            }).catch(() => {
                setMvms([]);
            }).finally(() => {
                setLoading(false);
            })
    }
    
    return (
        <Container maxWidth={false} component="main">

            <PageTitle title={t("mvmAutomatic")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form onSubmit={handleSubmit(onSubmit)} >

                        <Grid container spacing={1}>
                            <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {t("titleSearchAutomatic")}
                                </Typography>
                            </Grid>

                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI disabled={!hasPermission(permissions.MVM.Add)} color="secondary" onClick={() => { history.push('/SubmitMvm') }} startIcon={<AddIcon />}>{t("add")}</ButtonUI>
                                <ButtonUI onClick={() => reset()} startIcon={<BackspaceOutlinedIcon />}>{t("clean")}</ButtonUI>
                                <ButtonUI type="submit" color="primary" startIcon={<SearchIcon />}>{t("search")}</ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>
                            <Grid item xs={3}>
                            <SelectSupplier 
                                label={t("shippingCompanySupplier")}
                                name={"shippingCompanySupplier"}
                                control={control}
                                // onChange={handleShippingSupplierChange}
                                style={{width: '100%'}} 
                                // setValue={setValue}
                                multiple={false}
                                // loadUserSupplier={( === null)}
                                serviceType={'T'} /> 
                            </Grid>
                           
                            <Grid item xs={3}>
                                <TextField 
                                    label={t("invoiceKey")} 
                                    name="invoiceKey" 
                                    control={control} 
                                    type="number" 
                                    onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 44) }}
                                    fullWidth
                                />                                
                            </Grid>

                            <Grid item xs={1}>
                                <TextField label={t("invoiceNumber")} name="invoiceNumber" control={control} type="number" 
                                onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0,9) }}
                                fullWidth/>                                
                            </Grid>

                            <Grid item xs={2}>
                                <TextField 
                                    label={t("MDFeKey")} 
                                    name="MDFeKey" 
                                    control={control} 
                                    type="number" 
                                    onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 44) }}
                                    fullWidth
                                />                                
                            </Grid>

                            <Grid item xs={2}>
                                <TextField 
                                    label={t("CTeKey")} 
                                    name="CTeKey" 
                                    control={control} 
                                    type="number" 
                                    onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 44) }}
                                    fullWidth
                                />                                
                            </Grid>

                            <Grid item xs={1}>
                                <TextField 
                                    label={t("vehiclePlateNumber")} 
                                    name="vehiclePlateNumber" 
                                    control={control}
                                    mask="aaa9*99" 
                                    fullWidth/> 
                            </Grid>

                            <Grid item >
                                <Date label={t("submitDateStart")} name="submitDateStart" control={control} fullWidth/>
                            </Grid>  

                            <Grid item >
                                <Date label={t("submitDateEnd")} name="submitDateEnd" control={control} fullWidth/>                                
                            </Grid>

                            <Grid item xs={2}>
                                <TextField 
                                    label={t("UnitCargo")} 
                                    name="UnitCargo" 
                                    control={control}
                                    fullWidth/> 
                            </Grid>
                            
                            <Grid item xs={2}>
                                <ComboBox
                                    label={t('FinalDestination')} 
                                    name={'FinalDestination'}
                                    control={control} 
                                    options={[]}
                                    style={{width: '100%'}}/>
                            </Grid>                        

                        </Grid>
                    </form>

                    {
                        loading ? <LoadingUI /> :
                            <MuiThemeProvider theme={defaultGridTheme}>
                                <MUIDataTable
                                    title=""
                                    data={mvms?.items}
                                    columns={columns} 
                                       
                                    options={{
                                        ...getDefaultGridOptions(_t),
                                        serverSide: true,
                                        pagination: true,
                                        sort: false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                        page,
                                        count,
                                        rowsPerPage,
                                        onChangePage: (pageIndex) => { setPage(pageIndex) },
                                        onChangeRowsPerPage: (rowsPerPage) => { setPage(0); setRowsPerPage(rowsPerPage) },
                                    }}
                                />
                            </MuiThemeProvider>
                    }
                </div>
            </div>
        </Container>
    )
}
export default MvmAutomatico;
